module.exports = __webpack_public_path__ + "assets/img/customers1.29e52dc0.png";